"use strict";

var _require = require('@wix/web-bi-logger/dist/src/logger'),
    PublishMethods = _require.PublishMethods,
    factory = _require.factory;

var _require2 = require('@wix/fedops-logger'),
    create = _require2.create,
    phasesConfig = _require2.phasesConfig;

var BI_ENDPOINT = 'editor-performance';
var PRESET = 'EDITOR';

var clientLoggerFactory = function clientLoggerFactory(biStore) {
  var shouldBeMutedForFedOps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };
  return factory({
    publishMethod: PublishMethods.Auto,
    useBatch: true
  }).setMuted(shouldBeMutedForFedOps()).withUoUContext({
    msid: biStore.metaSiteId,
    visitorId: biStore.editorSessionId,
    siteMemberId: function siteMemberId() {
      return biStore.siteMemberId;
    }
  }).updateDefaults({
    is_rollout: biStore.is_rollout,
    origin: biStore.origin,
    type: 'none'
  });
};

var getFedOpsClientLogger = function getFedOpsClientLogger(biStore, muteFunc) {
  return create(biStore.fedOpsAppName, {
    endpoint: BI_ENDPOINT,
    isServerSide: false,
    biLoggerFactory: clientLoggerFactory(biStore, muteFunc),
    phasesConfig: phasesConfig.SEND_ON_FINISH,
    metasiteId: biStore.metaSiteId,
    presetType: PRESET
  });
};

module.exports = {
  getFedOpsClientLogger: getFedOpsClientLogger
};
//# sourceMappingURL=loggerFactory.js.map